import { request } from "@/lib/request";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";
import { captureEvent, sanitizeErrorReason } from "@/lib/analytics";

export const Route = createFileRoute("/connect-trello")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleToken = useCallback(async () => {
    if (!window.location.hash.includes("#token=")) {
      return;
    }
    const token = window.location.hash.split("=")[1];
    if (token) {
      captureEvent("onboarding_connect_started", {
        service: "trello",
        flow: "callback",
      });
      try {
        const res = await request.get(
          `/auth/trello/connect/callback?token=${token}`,
        );

        captureEvent("onboarding_connect_succeeded", {
          service: "trello",
          flow: "callback",
        });

        navigate({
          to: "/connect",
          search: { token: res.data.data.access_token },
        });
      } catch {
        captureEvent("onboarding_connect_failed", {
          service: "trello",
          flow: "callback",
          reason: sanitizeErrorReason("Trello callback failed"),
        });
        navigate({
          to: "/",
          search: {
            change_password_token: undefined,
            reset_password_token: undefined,
          },
        });
      }
    }
  }, [navigate]);

  useEffect(() => {
    handleToken();
  }, [handleToken]);

  return <div>Connecting...</div>;
}
